import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { doRestorePassword } from '../actions';
import getattr from '../utils/getattr';
import Collage from '../components/Collage'


class ForgotPasswordSent extends Component {

  render() {
    return (
      <div className="join-inner">
        <Collage />

        <div className="content-wrapper">
          <div className="join-forms">

            <div className="verify-wrapper">
              <div className="verify-checkmark">
                <img src="/images/icon_checkmark.png" />
                <p>Reset your password</p>
              </div>
              <div className="verify">
                <div className="verify-title">Time to check your email</div>
                <img src="/images/others/girl-chair-laptop.png" />
                <div className="verify-description">
                  <p>Please check your email and click the secure link. If you don't see our email, check your spam folder.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    doRestorePassword
  }
)(ForgotPasswordSent);



// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordSent.jsx